import { classes, throwUnsupportedValue } from 'src/utils'

type Props = {
  title?: string
  label: string
  color: 'red' | 'yellow' | 'green'
  className?: string
}

export default function Tag(props: Props) {
  return (
    <div
      title={props.title}
      className={classes(
        'flex items-center justify-center w-10 h-10 font-semibold rounded-full',
        getColors(props.color),
        props.className,
      )}
    >
      {props.label}
    </div>
  )
}

function getColors(color: Props['color']) {
  switch (color) {
    case 'green':
      return 'bg-green-100 text-green-500'
    case 'yellow':
      return 'bg-amber-100 text-amber-500'
    case 'red':
      return 'bg-red-100 text-red-500'
    default:
      throwUnsupportedValue(color)
  }
}
